export default "__VITE_ASSET__Cz1MA7s6__"